var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30017 18.6568V7.80711C6.39051 5.91001 7.68231 2.11581 12.1269 2.11581C16.5714 2.11581 17.9084 5.91001 18.0213 7.80711V18.6568",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6602 9.92635L12.2882 6.61581L7.72839 10.3013C7.9366 12.5707 9.14003 17.0846 12.2882 16.9846C15.4363 16.8847 16.5146 12.2375 16.6602 9.92635Z",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7487 22.8838C20.8568 21.5 20.3464 18.7452 17.4396 18.7969C14.5328 18.8485 14.2382 18.6502 14.2382 16.7238",
    stroke: "#707070",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25133 22.8842C3.1432 21.5004 3.65363 18.7457 6.56041 18.7973C9.46719 18.8489 9.76178 18.6506 9.76178 16.7242",
    stroke: "#707070",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.ae7efac255c7e8fa800a14fa3539fedd.svg";
export { ForwardRef as ReactComponent };